import { FundingSource } from '@melio/platform-api';

const getFundingSourceLastFourDigits = (fundingSource: FundingSource) => {
  switch (fundingSource.type) {
    case 'bank-account':
      return fundingSource.details.accountNumber.slice(-4);
    case 'card':
      return fundingSource.details.lastFourDigits;
  }
};

export const getFundingSourceLabel = (fundingSource: FundingSource) => {
  const lastFourDigits = getFundingSourceLastFourDigits(fundingSource);
  return `...${lastFourDigits}`;
};
